<template>
	<div class="cjt-container">
		<div class="cjt-head">
			<!-- 顶部导航栏 -->
			<top-nav-head></top-nav-head>
		</div>

		<div class="cjt-main">
			<!-- banner及内部导航栏区域--start -->
			<div class="banner-container">
				<!-- banner区域--start -->
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div v-for="(item, index) in bannerList" :key="index" class="swiper-slide">
							<div class="banner-content" :style="{ backgroundImage: `url(${item.imageUrl})` }">
								<!-- <img :src="`${item.imageUrl}`" alt="" /> -->
							</div>
						</div>
					</div>
					<div class="swiper-button-prev"></div>
					<div class="swiper-button-next"></div>
				</div>
				<!-- banner区域--end -->

				<!-- 导航区域--start -->
				<div class="nav-container">
					<div class="nav-content">
						<router-link
							v-for="(item, index) in navList"
							:key="index"
							:to="item.path"
							class="nav-item"
							:class="{ active: $route.path === item.path || $route.path === item.detailPath }"
						>
							<div class="icon-wrapper">
								<svg-icon :icon-class="item.icon" />
							</div>
							<span class="nav-text">{{ item.name }}</span>
						</router-link>
					</div>
				</div>
				<!-- 导航区域--end -->
			</div>
			<!-- banner及内部导航栏区域--end -->
			<!-- 导航切换主体区域 -->
			<router-view></router-view>
		</div>

		<!-- 底部服务流程向导 -->
		<footer-guide></footer-guide>

		<!-- 页脚 -->
		<page-footer></page-footer>
	</div>
</template>

<script>
	import TopNavHead from '@/components/TopNavHead'
	import PageFooter from '@/components/PageFooter'
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import FooterGuide from '@/components/FooterGuide/index'

	// 用工服务
	export default {
		name: 'Employment',
		components: {
			TopNavHead,
			FooterGuide,
			PageFooter
		},
		props: {},
		data() {
			return {
				bannerList: [
					{
						imageUrl: require('@/assets/employment/employment-banner.jpg')
					},
					{
						imageUrl: require('@/assets/employment/employment-banner.jpg')
					},
					{
						imageUrl: require('@/assets/employment/employment-banner.jpg')
					}
				],
				swiper: null,
				navList: [
					{
						name: '首页',
						path: '/employment/index',
						icon: 'home'
					},
					{
						name: '求职招聘专区',
						path: '/employment/recruitment-center',
						icon: 'hire'
					},
					{
						name: '我要招聘',
						path: '/employment/hire',
						icon: 'personManage'
					},
					{
						name: '我要求职',
						path: '/employment/job',
						icon: 'mail'
					}
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.$nextTick(() => {
				this.swiper = new Swiper('.swiper-container', {
					loop: true,
					// autoplay: false,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				})
			})
		},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/subNav.scss';

	.cjt-container {
		min-height: 100vh;
	}

	// 轮播图
	.banner-container {
		position: relative;
		z-index: 1;
		background-color: #f5f9fb;
		::v-deep {
			.swiper-container {
				width: 100%;
				height: 600px;
			}

			.banner-content {
				height: 600px;
				background-position: center;
				background-repeat: no-repeat;
				// background-size: cover;

				img {
					width: 100%;
				}
			}

			.swiper-button-prev,
			.swiper-button-next {
				width: 25px;
				height: 43px;

				&::after {
					font-size: 35px;
					color: #fff;
				}
			}

			.swiper-button-prev {
				left: 36px;
			}

			.swiper-button-next {
				right: 37px;
			}
		}
	}
</style>
